export const File_Types = [
  "image/apng",
  "image/bmp",
  "image/gif",
  "image/jpeg",
  "image/pjpeg",
  "image/png",
  "image/svg+xml",
  "image/tiff",
  "image/webp",
  "image/x-icon",
  "application/pdf",
  "message/rfc822",         // For .eml email files
  "application/vnd.ms-outlook",  // For .msg files,
  ""
];

export const Profile_File_Types = [
  "image/jpeg",
  "image/pjpeg",
  "image/png",
];

export const Resume_File_Types = [
  "application/msword", // .doc
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
  "application/vnd.openxmlformats-officedocument.wordprocessingml.template", // .dotx
];
